export class PaymentDto {
  applicationId: string;
  name: string;
  email: string;
  mobileNumber: string;
  type: string;
  address: string;
  paymentProfileId: number;
  amount: number;
  userId: number;
  noOfTraineeOrCandidates: number;
  constructor() { }
}
